module.exports = __webpack_public_path__ + "static/media/pt_complete2.eb2a98c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/pt_complete2.svg
// module id = 1815
// module chunks = 0